import React from 'react'
import { useSelector } from 'react-redux'

import { selectCloningStep } from '../../reducers/cloning_steps'
import { CloningStepsEnum } from '../../constants'

const StepIndicator = () => {
  const cloningStep = useSelector(selectCloningStep)

  return <span className={'cls-step-indicator'}>
    {window.I18n.t(
      `clone_leagues_sessions.general.cloning_step`,
      {step: cloningStep, steps: Object.keys(CloningStepsEnum).length},
    )}
  </span>
}

export default StepIndicator
